<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">ลิงก์สั้น</div>
          </div>
          <div class="actions">
            <router-link :to="'/custom-links/create'" class="btn btn-primary">
              <i class="fas fa-plus icon"></i> เพิ่มลิงก์สั้น
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <PreloaderSection
        v-if="loadCustomLinksState.isLoading" />
      <div v-if="!loadCustomLinksState.isLoading">
        <!-- render content -->
        <Section
          v-if="!loadCustomLinksState.error">
          <template v-slot:section-filter>
            <div class="search-container">
              <input
                class="form-control form-control-search"
                :value="filter.q"
                placeholder="ค้นหาลิงก์"
                @change="onSearch" />
            </div>
          </template>
          <!-- render content -->
          <template v-slot:section-body>
            <div v-if="!isEmpty()">
              <List>
                <template v-slot:list-header>
                  <div class="list-item-detail">
                    <div class="list-item list-item-primary">ลิงก์สั้น</div>
                    <div class="list-item list-item-title">ลิงก์ปลายทาง</div>
                    <div class="list-item">ชื่อลิงก์</div>
                    <div class="list-item list-item-action"></div>
                  </div>
                </template>
                <template v-slot:list-body>
                  <div class="list-item-container no-underline"
                    v-for="item in customLinks"
                    :key="item.id">
                    <div class="list-item-detail">
                      <div class="list-item list-item-primary">
                        <div @click="openEditModal(item.id)" class="title">www.altv.tv/{{item.locationUrl}}</div>
                        <small class="text-danger" v-if="isDeletingError(item.id)">
                          พบข้อผิดพลาดในการลบลิงก์ กรุณาลองใหม่อีกครั้ง หรือติตต่อผู้ดูแลระบบ
                        </small>
                      </div>
                      <div class="list-item list-item-title">
                        {{item.redirectUrl}}
                      </div>
                      <div class="list-item">
                        {{item.title}}
                      </div>
                      <div class="list-item list-item-action">
                        <div class="action-container">
                          <router-link class="btn btn-light btn-action" :to="`/custom-links/edit/${item.id}`">
                            <i class="fas fa-pencil-alt"></i>
                          </router-link>
                          <DoubleTabToConfirmButton
                            :disabled="isDeleting(item.id)"
                            @confirm="onDelete(item.id)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </List>
              <div
                class="pagination-container"
                v-if="isShowPagination()">
                <Pagination
                  :lastPage="lastPage" />
              </div>
            </div>
            <!-- empty list -->
            <EmptyMessage v-if="isEmpty()">
              <h3>ไม่มีข้อมูล</h3>
              <router-link
                class="btn btn-light btn-lg mt-4"
                :to="`/custom-links/create`">
                เพิ่มลิงก์สั้น
              </router-link>
            </EmptyMessage>
            <EmptyMessage v-if="isEmptySeach()">
              <h3>ไม่พบลิ้งก์ที่ค้นหา</h3>
              <button
                type="button"
                class="btn btn-light btn-lg mt-4"
                @click="clearSearch">
                ล้างการค้นหา
              </button>
            </EmptyMessage>
          </template>
        </Section>
        <!-- error from api -->
        <ErrorMessageCustomLinksContainer
          v-if="loadCustomLinksState.error"
          :error="loadCustomLinksState.error" />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import { loadCustomLinks, deleteCustomLinkById } from '@/customLinks/api';
import Page from '@/layouts/Page.vue';
import dateFormetter from '@/utils/dateFormatter';
import Pagination from '@/components/Pagination.vue';
import Section from '@/components/Section.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';
import DoubleTabToConfirmButton from '@/components/DoubleTapToConfirmButton.vue';
import ErrorMessageCustomLinksContainer from '@/customLinks/ErrorMessageCustomLinksContainer.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Page,
    Pagination,
    Section,
    List,
    EmptyMessage,
    ErrorMessageCustomLinksContainer,
    PreloaderSection,
    DoubleTabToConfirmButton,
  },
  data() {
    return {
      customLinks: null,
      lastPage: null,
      loadCustomLinksState: {
        isLoading: true,
        error: null,
      },
      deleteCutomLinkState: {
        isDeleting: false,
        error: null,
      },
    };
  },
  computed: {
    filter() {
      return this.$route.query;
    },
    // baseURL() {
    //   const env = process.env.NODE_ENV;
    //   if (env === 'production') {
    //     return 'https://altv.tv';
    //   }
    //   return process.env.VUE_APP_BASEURL || window.location.origin;
    // },
  },
  watch: {
    filter(newValue) {
      this.load(newValue);
    },
  },
  created() {
    this.load(this.filter);
  },
  methods: {
    async load(filter) {
      try {
        const response = await loadCustomLinks(filter);
        this.customLinks = response.data.data;
        this.lastPage = response.data.lastPage;
        this.loadCustomLinksState.isLoading = false;
      } catch (error) {
        this.loadCustomLinksState.error = error.response;
        this.loadCustomLinksState.isLoading = false;
      }
    },
    async onDelete(customLinkId) {
      try {
        this.deleteCutomLinkState.isDeleting = customLinkId;
        await deleteCustomLinkById(customLinkId);
        await this.load(this.filter);
        this.deleteCutomLinkState.isDeleting = false;
      } catch (error) {
        this.deleteCutomLinkState.error = error.response.data;
      }
    },
    isEmptySeach() {
      return _.isEmpty(this.customLinks) && !_.every(this.filter, _.isEmpty);
    },
    isEmpty() {
      return _.isEmpty(this.customLinks) && _.every(this.filter, _.isEmpty);
    },
    onSearch(event) {
      let filter;
      if (event.target.value) {
        filter = { ...this.filter, q: event.target.value };
      } else {
        filter = { ...this.filter };
        delete filter.q;
      }
      this.$router.push({ query: { ...filter } });
    },
    clearSearch() {
      const filter = null;
      this.$router.push({ query: { ...filter } });
    },
    isShowPagination() {
      return this.lastPage > 1;
    },
    isDeletingError(itemId) {
      if (this.isDeleting(itemId)) {
        return _.get(this.deleteCutomLinkState, 'error', null);
      }
      return false;
    },
    isDeleting(itemId) {
      return this.deleteCutomLinkState.isDeleting === itemId;
    },
    openEditModal(id) {
      this.$router.push(`/custom-links/edit/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/form.scss';

@media (max-width: 575.98px) {
  .list-item-container {

    .list-item-detail {
      .list-item {
        font-size: $font-size-base * 0.875;
        width: 70%;
        display: none;

        &.list-item-primary {
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: $spacer * 0.25;
        }

        &.list-item-title {
          flex-direction: column;
          align-items: flex-start;
        }

        &.list-item-secondary {
          display: flex;
          order: -1;
          padding: $spacer * 0.25;
          font-size: $font-size-base * 0.875;
        }

        &.list-item-status {
          display: flex;
        }

        &.list-item-status {
          display: none;
        }
        &.list-item-create-at {
          display: none;
        }
        &.list-item-action {
          .action-container {
            .btn-external {
              display: none;
            }
          }
        }
      }
    }
  }
}

@media (min-width: 576px) and (max-width: 1023.98px) {

  .list-item-container {
    .list-item-image {
    }

    .list-item-detail {
      .list-item {
        &.list-item-status {
          display: none;
        }
        &.list-item-create-at {
          display: none;
        }
        &.list-item-action {
          .action-container {
            .btn-external {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
